import axios from 'axios'
//
// initial state
const state = {
  cartItems: [],
  errorMessage: 'Produkten finns inte.',
  totalItems: 0,
  totalPrice: {
    prefix: null,
    price: 0,
    printPrice: '0',
    suffix: 'kr'
  },
  status: {
    loading: false,
    error: false,
    success: false
  }
}

// getters
const getters = {
  cartProducts: (state) => {
    return state.cartItems.map( item => {
      return {
        id: item.ItemId,
        quantity: item.Quantity,
        description: item.Description,
        price: {
          prefix: item.Price.Prefix,
          price: item.Price.Price,
          printPrice: item.Price.PrintPrice,
          suffix: item.Price.Suffix
        },
        image: item.Image,
        isInstallation: item.IsInstallation,
        isNormal: item.IsNormal,
        name: item.Name,
        urlPath: item.UrlPath,
        url: item.Url
      }
    })
  },
  totalPrice: (state) => {
    const priceString = state.totalPrice.printPrice + ' ' + state.totalPrice.suffix
    return priceString
  },
}

// actions
const actions = {
  // Get cart
  getCart ({ commit, dispatch }, { api }) {
    commit('setStatus', { loading: true })
    commit('setStatus', { success: false })
    commit('setStatus', { error: false })

    axios.get(api)
      .then(response => {
        let data = !!response && response?.data?.Data
          ? response.data.Data
          : null

        // console.log('GET CART API RESPONSE:', data)
        dispatch('setCartState', data)
      })
      .catch(error => {
        // console.log('GET CART ERROR:', error)
        commit('setStatus', { success: false })
        commit('setStatus', { error: true })
      })
      .finally(() => commit('setStatus', { loading: false }))
  },
  // Set cart
  setCart ({ commit, dispatch }, { api, params }) {
    commit('setStatus', { loading: true })
    commit('setStatus', { success: false })
    commit('setStatus', { error: false })

    axios.post(api, params)
      .then(response => {
        let data = !!response && response?.data?.Data
          ? response.data.Data
          : null

        // console.log('SET CART API RESPONSE:', data)
        dispatch('setCartState', data)
      })
      .catch(error => {
        // console.log('SET CART ERROR:', error)
        commit('setStatus', { success: false })
        commit('setStatus', { error: true })
      })
      .finally(() => commit('setStatus', { loading: false }))
  },
  // Set cart state
  setCartState ({ commit }, data) {
    const items = !!data && data?.Items
      ? data.Items
      : null
    const totalPrice = !!data && data?.TotalPrice
      ? data.TotalPrice
      : null
    const totalItems = !!data && data.TotalItems
      ? data.TotalItems
      : 0

    commit('setCartItems', items)
    commit('setTotalPrice', totalPrice)
    commit('setTotalItems', totalItems)
    commit('setStatus', { success: true })
  }
}

// mutations
const mutations = {

  setCartItems (state, items) {
    state.cartItems = !items ? [] : items
  },

  setTotalPrice (state, totalPrice) {
    const totalPriceObj = !totalPrice ? state.totalPrice : totalPrice
    const prefix = !totalPriceObj.Prefix ? state.totalPrice.prefix : totalPriceObj.Prefix
    const price = !totalPriceObj.Price ? state.totalPrice.price : totalPriceObj.Price
    const printPrice = !totalPriceObj.PrintPrice ? state.totalPrice.printPrice : totalPriceObj.PrintPrice
    const suffix = !totalPriceObj.Suffix ? state.totalPrice.suffix : totalPriceObj.Suffix

    state.totalPrice = {
      prefix: prefix,
      price: price,
      printPrice: printPrice,
      suffix: suffix
    }
  },

  setTotalItems (state, totalItems) {
    state.totalItems = totalItems
  },

  setStatus (state, statusObj) {
    const key = Object.keys(statusObj)[0]
    const value = Object.values(statusObj)[0]
    state.status[key] = value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
